import {sourcingFilterConstants} from '../../../../../../../constants/sourcingFilterConstants';
import {UNBOUNDED_PRICE} from '../../../../../../../constants/UNBOUNDED_PRICE';

// Display scales, not exchange rates. Prices continue to use the account currency in requests.
const PRICE_SCALES: Record<string, number[]> = {
  CZK: [0, 100000, 250000, 500000, 750000, 1000000, 1500000, 2000000, 3000000, 4000000],
  EUR: [0, 5000, 10000, 15000, 20000, 30000, 40000, 50000, 75000, 100000, 200000],
  PLN: [0, 25000, 50000, 75000, 100000, 150000, 200000, 300000, 500000, 1000000],
  GBP: [0, 5000, 10000, 15000, 20000, 30000, 40000, 50000, 75000, 100000, 200000],
  CHF: [0, 5000, 10000, 15000, 20000, 30000, 40000, 50000, 75000, 100000, 200000],
  HUF: [0, 2000000, 5000000, 10000000, 15000000, 20000000, 30000000, 50000000, 80000000],
  RON: [0, 25000, 50000, 75000, 100000, 150000, 200000, 300000, 500000, 1000000],
  SEK: [0, 50000, 100000, 200000, 300000, 500000, 750000, 1000000, 1500000, 2000000],
  NOK: [0, 50000, 100000, 200000, 300000, 500000, 750000, 1000000, 1500000, 2000000],
  DKK: [0, 25000, 50000, 100000, 200000, 300000, 500000, 750000, 1000000, 1500000],
};

export function getPriceSliderRange(
  currency: string,
  stored?: [number, number],
  storedMax = UNBOUNDED_PRICE
) {
  const scale =
    PRICE_SCALES[currency] ?? sourcingFilterConstants.PRICE_MARKS.map((mark) => mark.value);
  const scaleMax = scale[scale.length - 1];
  // The caller identifies legacy persisted ranges so a new finite 4M HUF remains finite.
  const isUnbounded = stored?.[1] === storedMax;
  const finiteMax = isUnbounded ? 0 : (stored?.[1] ?? 0);
  // Leave room above older finite values so opening the editor never turns them into infinity.
  const max = Math.max(
    scaleMax,
    finiteMax >= scaleMax ? finiteMax * 2 : scaleMax,
    (stored?.[0] ?? 0) * 2
  );
  const value: [number, number] | undefined = stored
    ? [stored[0], isUnbounded ? max : stored[1]]
    : undefined;
  const marks = [...new Set([0, ...scale, max])].sort((a, b) => a - b).map((value) => ({value}));
  const toStored = (range: [number, number]): [number, number] => [
    range[0],
    range[1] === max ? UNBOUNDED_PRICE : range[1],
  ];
  return {max, marks, value, toStored};
}
